import React, { Component } from "react";

class SketchPad extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="wrapper">
        {/* <!-- Navbar --> */}
        <nav
          className="main-header navbar navbar-expand navbar-white navbar-light custom-navbar nav-z-index"
          id="ml_0"
        >
          {/* <!-- Left navbar links --> */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link"
                id="mbl_menu"
                data-widget="pushmenu"
                href="#"
                role="button"
              >
                <i className="fas fa-bars"></i>
              </a>
            </li>
          </ul>

          {/* <!-- SEARCH FORM --> */}
          <form className="form-inline ml-3">
            <div className="input-group input-group-sm">
              <img
                src="dist/img/logo.PNG"
                alt="Logo"
                className="img-fluid mr-2 ml-2"
              />
            </div>
            <div className="input-group input-group-sm">
              <h6 className="m-0 pt-2 pl-5 ml-5 text-white">
                Digital Comfort Guide - Admin Portal
              </h6>
            </div>
          </form>
        </nav>
        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <aside className="main-sidebar sidebar-dark-primary elevation-4 mbl-overflow-hide">
          {/* <!-- Sidebar --> */}
          <div className="sidebar p-0">
            {/* <!-- Sidebar Menu --> */}
            <nav>
              <div id="accordion">
                <div className="card left-menu-bar-new mb-0">
                  <div className="card-header">
                    <a
                      className="card-link"
                      data-toggle="collapse"
                      href="#collapseOne"
                    >
                      <b>Reports</b>
                      <i className="fas fa-chevron-down float-right mt-1"></i>
                    </a>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    data-parent="#accordion"
                  >
                    <div className="card-body p-0">
                      <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                      >
                        <li className="nav-item">
                          <a
                            href="daily-summary.html"
                            className="nav-link custom-nav-link"
                            id="sketchpad"
                          >
                            <img
                              src="dist/img/summary.png"
                              className="img-fluid sketchpad_img"
                            />
                            <span>Daily Summary</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            href="associate-comparison.html"
                            className="nav-link custom-nav-link"
                          >
                            <img
                              src="dist/img/associate-icon.png"
                              className="img-fluid"
                            />
                            <span>Associate Comparison</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            href="store-comparison.html"
                            className="nav-link custom-nav-link"
                          >
                            <img
                              src="dist/img/store-comparison-icon.png"
                              className="img-fluid"
                            />
                            <span>Store Comparison</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            href="market-comparison.html"
                            className="nav-link custom-nav-link"
                          >
                            <img
                              src="dist/img/market-comparison.png"
                              className="img-fluid size40"
                            />
                            <span>Market Comparison</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card left-menu-bar-new mb-0">
                  <a className="plane-menus" href="digital-questions.html">
                    <div className="card-header active">
                      Digital Comfort Guide Questions
                    </div>
                  </a>
                </div>
              </div>
            </nav>
            {/* <!-- /.sidebar-menu --> */}
          </div>
          {/* <!-- /.sidebar --> */}
        </aside>

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper pb-4">
          {/* <!-- Main content --> */}
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="mt-2 mb-0">Digital Comfort Guide Questions</h5>
                </div>
                <div className="col-md-6 text-right">
                  <a href="#" className="btn btn-primary pt-2">
                    Publish
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-12">
                  <a href="#" className="btn btn-outline-primary pt-2">
                    Add a Section
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <hr />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary">
                    <div className="card-header pt-0 pb-0">
                      {/* <!-- <h3 className="card-title">Section</h3> --> */}
                      <div className="row">
                        <div className="col-md-6 mt-2 mb-2">
                          <div className="row d-flex-right">
                            <div className="col-md-2">
                              <h3 className="card-title">
                                <i
                                  className="fa fa-bars"
                                  aria-hidden="true"
                                ></i>{" "}
                                Section
                              </h3>
                            </div>
                            <div className="col-md-10">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Tell me About Your Room - Design"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 mt-2 mb-2 text-right d-flex-right">
                          <a href="" className="btn  btn-default btn-sm mr-3">
                            Add a Question
                          </a>
                          <div className="card-tools">
                            <button
                              type="button"
                              className="btn btn-tool"
                              data-card-widget="collapse"
                            >
                              <i className="fas fa-minus"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* <!-- /.card-tools --> */}
                    </div>
                    {/* <!-- /.card-header --> */}
                    <div className="card-body grey-bg-card">
                      <section className="questions">
                        <div className="row">
                          <div className="col-md-1">
                            <i
                              className="fa fa-bars grey-bars"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="col-md-10 pt-3 pb-3">
                            <div className="row mbl-padding">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Question</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="What is your style?"
                                  />
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Market</label>
                                  <select className="form-control">
                                    <option>Multi Select Checkboxes</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Response Options{" "}
                                    <small>
                                      (Type and press enter to add options)
                                    </small>
                                  </label>
                                  <div className="position-box">
                                    <textarea
                                      className="form-control"
                                      rows="5"
                                    ></textarea>
                                    <section className="list-menu-box">
                                      <div className="col-md-12 p-0">
                                        <ul className="response-list">
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <input
                                              type="text"
                                              className="border-0 outline"
                                              autofocus
                                              placeholder="Type Here..."
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-md-12 mt-3 text-right">
                                        <a href="">Add "Other"</a>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 pt-3 pr-4 text-right">
                            <a href="">
                              <i className="far fa-trash-alt trash"></i>
                            </a>
                          </div>
                        </div>
                      </section>

                      <section className="questions">
                        <div className="row">
                          <div className="col-md-1">
                            <i
                              className="fa fa-bars grey-bars"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="col-md-10 pt-3 pb-3">
                            <div className="row mbl-padding">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Question</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="What is your style?"
                                  />
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Market</label>
                                  <select className="form-control">
                                    <option>Multi Select Checkboxes</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Response Options{" "}
                                    <small>
                                      (Type and press enter to add options)
                                    </small>
                                  </label>
                                  <div className="position-box">
                                    <textarea
                                      className="form-control"
                                      rows="5"
                                    ></textarea>
                                    <section className="list-menu-box">
                                      <div className="col-md-12 p-0">
                                        <ul className="response-list">
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <input
                                              type="text"
                                              className="border-0 outline"
                                              autofocus
                                              placeholder="Type Here..."
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-md-12 mt-3 text-right">
                                        <a href="">Add "Other"</a>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 pt-3 pr-4 text-right">
                            <a href="">
                              <i className="far fa-trash-alt trash"></i>
                            </a>
                          </div>
                        </div>
                      </section>

                      <section className="questions">
                        <div className="row">
                          <div className="col-md-1">
                            <i
                              className="fa fa-bars grey-bars"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="col-md-10 pt-3 pb-3">
                            <div className="row mbl-padding">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Question</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="What is your style?"
                                  />
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Market</label>
                                  <select className="form-control">
                                    <option>Multi Select Checkboxes</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Response Options{" "}
                                    <small>
                                      (Type and press enter to add options)
                                    </small>
                                  </label>
                                  <div className="position-box">
                                    <textarea
                                      className="form-control"
                                      rows="5"
                                    ></textarea>
                                    <section className="list-menu-box">
                                      <div className="col-md-12 p-0">
                                        <ul className="response-list">
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <input
                                              type="text"
                                              className="border-0 outline"
                                              autofocus
                                              placeholder="Type Here..."
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-md-12 mt-3 text-right">
                                        <a href="">Add "Other"</a>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 pt-3 pr-4 text-right">
                            <a href="">
                              <i className="far fa-trash-alt trash"></i>
                            </a>
                          </div>
                        </div>
                      </section>

                      <section className="questions">
                        <div className="row">
                          <div className="col-md-1">
                            <i
                              className="fa fa-bars grey-bars"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="col-md-10 pt-3 pb-3">
                            <div className="row mbl-padding">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Question</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="What is your style?"
                                  />
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Market</label>
                                  <select className="form-control">
                                    <option>Multi Select Checkboxes</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Response Options{" "}
                                    <small>
                                      (Type and press enter to add options)
                                    </small>
                                  </label>
                                  <div className="position-box">
                                    <textarea
                                      className="form-control"
                                      rows="5"
                                    ></textarea>
                                    <section className="list-menu-box">
                                      <div className="col-md-12 p-0">
                                        <ul className="response-list">
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <input
                                              type="text"
                                              className="border-0 outline"
                                              autofocus
                                              placeholder="Type Here..."
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-md-12 mt-3 text-right">
                                        <a href="">Add "Other"</a>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 pt-3 pr-4 text-right">
                            <a href="">
                              <i className="far fa-trash-alt trash"></i>
                            </a>
                          </div>
                        </div>
                      </section>
                    </div>
                    {/* <!-- /.card-body --> */}
                  </div>
                  {/* <!-- /.card --> */}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary">
                    <div className="card-header pt-0 pb-0">
                      {/* <!-- <h3 className="card-title">Section</h3> --> */}
                      <div className="row">
                        <div className="col-md-6 mt-2 mb-2">
                          <div className="row d-flex-right">
                            <div className="col-md-2">
                              <h3 className="card-title">
                                <i
                                  className="fa fa-bars"
                                  aria-hidden="true"
                                ></i>{" "}
                                Section
                              </h3>
                            </div>
                            <div className="col-md-10">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Tell me About Your Room - Space"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 mt-2 mb-2 text-right d-flex-right">
                          <a href="" className="btn  btn-default btn-sm mr-3">
                            Add a Question
                          </a>
                          <div className="card-tools">
                            <button
                              type="button"
                              className="btn btn-tool"
                              data-card-widget="collapse"
                            >
                              <i className="fas fa-minus"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* <!-- /.card-tools --> */}
                    </div>
                    {/* <!-- /.card-header --> */}
                    <div className="card-body grey-bg-card">
                      <section className="questions">
                        <div className="row">
                          <div className="col-md-1">
                            <i
                              className="fa fa-bars grey-bars"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="col-md-10 pt-3 pb-3">
                            <div className="row mbl-padding">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Question</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="What is your style?"
                                  />
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Market</label>
                                  <select className="form-control">
                                    <option>Multi Select Checkboxes</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Response Options{" "}
                                    <small>
                                      (Type and press enter to add options)
                                    </small>
                                  </label>
                                  <div className="position-box">
                                    <textarea
                                      className="form-control"
                                      rows="5"
                                    ></textarea>
                                    <section className="list-menu-box">
                                      <div className="col-md-12 p-0">
                                        <ul className="response-list">
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <input
                                              type="text"
                                              className="border-0 outline"
                                              autofocus
                                              placeholder="Type Here..."
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-md-12 mt-3 text-right">
                                        <a href="">Add "Other"</a>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 pt-3 pr-4 text-right">
                            <a href="">
                              <i className="far fa-trash-alt trash"></i>
                            </a>
                          </div>
                        </div>
                      </section>

                      <section className="questions">
                        <div className="row">
                          <div className="col-md-1">
                            <i
                              className="fa fa-bars grey-bars"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="col-md-10 pt-3 pb-3">
                            <div className="row mbl-padding">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Question</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="What is your style?"
                                  />
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Market</label>
                                  <select className="form-control">
                                    <option>Multi Select Checkboxes</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Response Options{" "}
                                    <small>
                                      (Type and press enter to add options)
                                    </small>
                                  </label>
                                  <div className="position-box">
                                    <textarea
                                      className="form-control"
                                      rows="5"
                                    ></textarea>
                                    <section className="list-menu-box">
                                      <div className="col-md-12 p-0">
                                        <ul className="response-list">
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <input
                                              type="text"
                                              className="border-0 outline"
                                              autofocus
                                              placeholder="Type Here..."
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-md-12 mt-3 text-right">
                                        <a href="">Add "Other"</a>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 pt-3 pr-4 text-right">
                            <a href="">
                              <i className="far fa-trash-alt trash"></i>
                            </a>
                          </div>
                        </div>
                      </section>

                      <section className="questions">
                        <div className="row">
                          <div className="col-md-1">
                            <i
                              className="fa fa-bars grey-bars"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="col-md-10 pt-3 pb-3">
                            <div className="row mbl-padding">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Question</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="What is your style?"
                                  />
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label>Market</label>
                                  <select className="form-control">
                                    <option>Multi Select Checkboxes</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Response Options{" "}
                                    <small>
                                      (Type and press enter to add options)
                                    </small>
                                  </label>
                                  <div className="position-box">
                                    <textarea
                                      className="form-control"
                                      rows="5"
                                    ></textarea>
                                    <section className="list-menu-box">
                                      <div className="col-md-12 p-0">
                                        <ul className="response-list">
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="">
                                              Traditional{" "}
                                              <i className="fas fa-times text-primary"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <input
                                              type="text"
                                              className="border-0 outline"
                                              autofocus
                                              placeholder="Type Here..."
                                            />
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-md-12 mt-3 text-right">
                                        <a href="">Add "Other"</a>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 pt-3 pr-4 text-right">
                            <a href="">
                              <i className="far fa-trash-alt trash"></i>
                            </a>
                          </div>
                        </div>
                      </section>
                    </div>
                    {/* <!-- /.card-body --> */}
                  </div>
                  {/* <!-- /.card --> */}
                </div>
              </div>
            </div>
          </section>
          {/* <!-- /.content --> */}
        </div>
        {/* <!-- /.content-wrapper --> */}

        <div className="modal fade mt-5" id="notes">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Notes</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Notes</label>
                      <textarea rows="8" className="form-control"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default">
                  Cancel
                </button>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </div>
            {/* <!-- /.modal-content --> */}
          </div>
          {/* <!-- /.modal-dialog --> */}
        </div>
        {/* <!-- /.modal --> */}

        {/* <!-- <footer className="main-footer text-right">
   
    Copyright &copy; 2021 <a href="http://www.la-z-boyindia.com/" target="_blank" >LAZBOY</a>. All rights
    reserved.
  </footer> --> */}

        {/* <!-- Control Sidebar --> */}
        <aside className="control-sidebar control-sidebar-dark">
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
    );
  }
}
export default SketchPad;
